import Header from '../Component/Header'
import Footer from '../Component/Footer'
import Breadcrumb from '../Component/Breadcrumb'
const ManagingCommitee = () => {
    return (
        <>
            <Header />
            <Breadcrumb title="Managing Committee" midBreadcrumb="Office Bearers" mainBreadcrumb="Managing Committee" ></Breadcrumb>
            <div className='inner-page'>
                <div className='container'>
                    <div className="col-12">
                        <h2 className="mainhead">Managing Committee</h2>
                        <h3 className="subhead">A committee is a group that keeps minutes and loses hours</h3>
                        <div className="tablescroll table-responsive">
                            <table className="table table-bordered text-center">
                                <thead>
                                    <tr>
                                        <th width="10%">S. No.</th>
                                        <th width="45%">Name</th>
                                        <th width="45%">Designation</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>1.</td>
                                        <td>Rev. Fr. Vincent D'Souza </td>
                                        <td>Chairman</td>
                                    </tr>
                                    <tr>
                                        <td>2.</td>
                                        <td>Rt. Rev. Deepak Valerian Tauro (Auxiliary Bishop) </td>
                                        <td>Member</td>
                                    </tr>
                                    <tr>
                                        <td>3.</td>
                                        <td>Rev. Fr. Thavamani</td>
                                        <td>Director for Education DCA </td>
                                    </tr>
                                    <tr>
                                        <td>4.</td>
                                        <td>Rev. Fr Anthony : M. Fernandes</td>
                                        <td>Vice Chairman/Manager</td>
                                    </tr>
                                    <tr>
                                        <td>5.</td>
                                        <td>Rev. Fr. John M. Fernandes </td>
                                        <td>Principal cum Secretary</td>
                                    </tr>
                                    <tr>
                                        <td>6.</td>
                                        <td>Rev. Fr. Irudaya Kumar</td>
                                        <td>Member</td>
                                    </tr>
                                    <tr>
                                        <td>7.</td>
                                        <td>Sr. Greta </td>
                                        <td>Headmistress, Member</td>
                                    </tr>
                                    <tr>
                                        <td>8.</td>
                                        <td>Mr. Cyril Basil</td>
                                        <td>Educational Consultant</td>
                                    </tr>
                                    <tr>
                                        <td>9.</td>
                                        <td>Mr. Joseph Prabhakar</td>
                                        <td>Educational Consultant</td>
                                    </tr>
                                    <tr>
                                        <td>10.</td>
                                        <td>Mrs. Kamlesh Sharma</td>
                                        <td>Staff Representative, Member</td>
                                    </tr>
                                    <tr>
                                        <td>11.</td>
                                        <td>Mrs. Geeta Yadav</td>
                                        <td>Staff Representative, Member</td>
                                    </tr>
                                    <tr>
                                        <td>12.</td>
                                        <td>Mrs. Gagan Singhal</td>
                                        <td>Parent Representative</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}
export default ManagingCommitee